import { useContext } from "react";
import { ControlContext } from "../ControlContext.jsx";

import AlumiumProfile from "./FrameComp/BoxFrame/AluminumProfile";
import Glass from "./FrameComp/Glass";
import ChangeDepths from "../Helpers/ChangeDepths.jsx";

export default function AluminumFrame({}) {
  const { glassInsert } = useContext(ControlContext);

  const { glassDepth } = ChangeDepths();

  return (
    <>
      <AlumiumProfile glassInsert={glassInsert} />
      <Glass glassDepth={glassDepth} />
    </>
  );
}
